<div class="row" *ngIf="pools && channels && !showCreationQueue">
  <sb-card-loading-spinner *ngIf="blockBackdrop"></sb-card-loading-spinner>
  <div class="col-12 tw-mb-2">
    <div class="tablewrap">
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100 tw-font-bold">{{ 'lang.globals.amountOfDevices' | translate }}</p>
          <p class="w-100 tr">
            <input type="number" class="form-control text-right" placeholder="..." [min]="1" [ngModel]="amount"
                   (ngModelChange)="onAmount($event)">
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="tablewrap">
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">{{ 'lang.globals.identifier' | translate }}</p>
          <p class="w-100 tr">
            <input type="text" class="form-control text-right" placeholder="..." [ngModel]="identifier"
                   (ngModelChange)="onIdentifier($event)" sbAutofocus>
          </p>
        </div>
      </div>
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">Name</p>
          <p class="w-100 tr">
            <input type="text" class="form-control text-right" placeholder="..." [ngModel]="name"
                   (ngModelChange)="onName($event)">
          </p>
        </div>
      </div>
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">Productive</p>
          <p class="w-100 tr">
            <sb-toggle-switch onText="{{ 'lang.globals.yes' | translate }}"
                              offText="{{ 'lang.globals.no' | translate }}"
                              [(model)]="productive"></sb-toggle-switch>
          </p>
        </div>
      </div>
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">No SIM</p>
          <p class="w-100 tr">
            <sb-toggle-switch onText="{{ 'lang.globals.yes' | translate }}"
                              offText="{{ 'lang.globals.no' | translate }}"
                              [(model)]="offline"></sb-toggle-switch>
          </p>
        </div>
      </div>
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">Disabled</p>
          <p class="w-100 tr">
            <sb-toggle-switch onText="{{ 'lang.globals.yes' | translate }}"
                              offText="{{ 'lang.globals.no' | translate }}"
                              [(model)]="disabled"></sb-toggle-switch>
          </p>
        </div>
      </div>
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">External</p>
          <p class="w-100 tr">
            <sb-toggle-switch onText="{{ 'lang.globals.yes' | translate }}"
                              offText="{{ 'lang.globals.no' | translate }}"
                              [(model)]="external"></sb-toggle-switch>
          </p>
        </div>
      </div>
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">{{ 'lang.globals.mobility' | translate }}</p>
          <p class="w-100 tr">
            <sb-toggle-switch [disabled]="!permissionService.hasPermission(permissionService.Permission.device_properties_edit)"
                              onText="{{ 'lang.globals.yes' | translate }}"
                              offText="{{ 'lang.globals.no' | translate }}"
                              [(model)]="isDeviceMobile"></sb-toggle-switch>
          </p>
        </div>
      </div>
      <div
        class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header"
        *ngIf="isDeviceMobile">
        <!--
        <mat-slider (valueChange)="duration = $event"
                    [disabled]="!isDeviceMobile" [max]="3600"
                    [min]="1" [step]="1" [value]="duration" aria-label="units">
        </mat-slider>
        <div class="input-group">
        -->
        <p class="w-100">{{ 'lang.globals.refreshRate'|translate }} </p>
        <p class="w-100 tr d-flex align-items-center mr-1">
          <input class="form-control tr" type="number" [min]="1" [max]="86400" [(ngModel)]="duration"
                 [disabled]="!isDeviceMobile || !permissionService.hasPermission(permissionService.Permission.device_properties_edit)"
                 [placeholder]="'seconds'">
          s

        </p>
      </div>
      <div class="d-flex flex-row bb" *ngPermissions="[permissionService.Permission.pool_list]">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">Pool</p>
          <div ngbDropdown placement="bottom-right" class="w-100 tr" style="margin-top: -14px;">
            <button class="btn btn-outline-primary" ngbDropdownToggle>
              <sb-value-definition [text]="getPoolText()"></sb-value-definition>
            </button>
            <div ngbDropdownMenu class="scrollable-menu">
              <button ngbDropdownItem (click)="setPool(null)"
                      [ngClass]="!pool ? 'active' : ''"><i>&#91;n. def.&#093;</i></button>
              <button ngbDropdownItem *ngFor="let poo of pools" (click)="setPool(poo)"
                      [ngClass]="poo === pool ? 'active' : ''">{{ poo.name }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row bb" *ngPermissions="[permissionService.Permission.location_list]">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">Location</p>
          <div class="w-100 tr" style="margin-top: -14px;">
            <button class="btn btn-outline-primary" (click)="selectLocation()">
              <i *ngIf="getLocationText() === 'n. def.'; else locationTextElse">
                &#91;{{ getLocationText() }}&#093;
              </i>
              <ng-template #locationTextElse>
                {{ getLocationText() }}
              </ng-template>
            </button>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row bb" *ngPermissions="[permissionService.Permission.channel_list]">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">Channel</p>
          <div ngbDropdown placement="bottom-right" class="w-100 tr" style="margin-top: -14px;">
            <button class="btn btn-outline-primary" ngbDropdownToggle>
              <sb-value-definition [text]="getChannelText()"></sb-value-definition>
            </button>
            <div ngbDropdownMenu class="scrollable-menu">
              <button ngbDropdownItem *ngFor="let chan of channels"
                      (click)="setChannel(chan)"
                      [ngClass]="chan === channel ? 'active' : ''">{{ chan.name }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row bb" *ngIf="screens?.length > 0">
        <div class="mt-3 ml-3 w-100">
          <h5>
            {{ 'lang.globals.screens'|translate }}
          </h5>
          <div
            class="mt-3 align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header ml-0">
            <ng-scrollbar class="mt-2" style="height: 150px; width: 100%" [track]="'vertical'">

              <div *ngFor="let screen of screens" class="bb tw-mr-5">

                <div class="d-flex w-100 justify-content-between">
                  <div>{{ 'lang.globals.screen'|translate }}: {{ screen?.id }}</div>
                  <div>{{ screen?.marker?.resolution?.id }}</div>
                </div>
                <div
                  class="mt-2 align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.name' | translate }}</p>
                  <p class="w-100 tr">
                    <input [disabled]="!permissionService.hasPermission(permissionService.Permission.device_properties_edit) || true"
                           type="text"
                           class="form-control text-right" placeholder="..." [(ngModel)]="screen.name">
                  </p>
                </div>
                <div class="d-flex"
                     *ngPermissions="[permissionService.Permission.screen_hardware_list]"
                >
                  <p class="w-100 tw-flex-wrap">{{ 'lang.globals.screenHardware'| translate }}</p>
                  <div placement="bottom-right" class="w-100 tr"
                       style="margin-top: -14px; padding-top:13px; padding-bottom: 13px;">
                    <sb-comp-dropdown-select
                      [singleSelectMode]="true" [showSubmit]="false"
                      [inputData]="screenHardwareList" [dropDownDatatype]="'SCREEN_HARDWARE'"
                      (selectedDataEmitter)="msUpdate($event, 'SCREEN_HARDWARE', screen)" [showColumnIcon]="false"
                      [showIcon]="false"
                      [msOptions]="msScreenHardwareOptions" (msOptionsChange)="msRequest('SCREEN_HARDWARE', $event)"
                      [selectedInputData]="screen?.hardware ? [screen?.hardware] : []">
                    </sb-comp-dropdown-select>
                  </div>
                </div>
                <div class="d-flex"
                     *ngIf="permissionService.hasPermission(permissionService.Permission.medium_transformation_list) && mediumTransformations?.length > 0">
                  <p class="w-100">{{ 'lang.globals.mediumTransformation'|translate }}</p>
                  <div placement="bottom-right" class="w-100 tr"
                       style="margin-top: -14px; padding-top:13px; padding-bottom: 13px;">
                    <sb-comp-dropdown-select
                      [singleSelectMode]="true" [showSubmit]="false"
                      [inputData]="mediumTransformations" [dropDownDatatype]="'MEDIUM_TRANSFORMATION'"
                      (selectedDataEmitter)="msUpdate($event, 'MEDIUM_TRANSFORMATION', screen)" [showColumnIcon]="false"
                      [showIcon]="false"
                      [msOptions]="msMediumTransformationsOptions" (msOptionsChange)="msRequest('MEDIUM_TRANSFORMATION', $event)"
                      [selectedInputData]="screen?.mediumTransformation ? [screen?.mediumTransformation] : []">
                    </sb-comp-dropdown-select>
                  </div>
                </div>
              </div>
            </ng-scrollbar>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row bb" *ngPermissions="[permissionService.Permission.player_hardware_list]">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">{{ 'lang.globals.playerHardware' | translate }}</p>
          <div class="d-flex justify-content-end" style="margin-top: -14px; margin-right: -5px;">
            <sb-comp-dropdown-select
              id="Hardware"
              [singleSelectMode]="true" [showSubmit]="false"
              [inputData]="playerHardwareList" [dropDownDatatype]="'PLAYER_HARDWARE'"
              (selectedDataEmitter)="msUpdate($event, 'PLAYER_HARDWARE')" [showColumnIcon]="false"
              [showIcon]="false"
              [msOptions]="msPlayerHardwareOptions" (msOptionsChange)="msRequest('PLAYER_HARDWARE', $event)"
              [selectedInputData]="playerHardware ? [playerHardware] : []">
            </sb-comp-dropdown-select>
          </div>
        </div>
      </div>

      <div class="d-flex flex-row bb" *ngPermissions="[permissionService.Permission.player_software_list]">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">{{ 'lang.globals.playerSoftware' | translate }}</p>
          <div class="d-flex justify-content-end" style="margin-top: -14px; margin-right: -5px;">
            <sb-comp-dropdown-select
              id="Software"
              [singleSelectMode]="true" [showSubmit]="false"
              [inputData]="playerSoftwareList" [dropDownDatatype]="'PLAYER_SOFTWARE'"
              (selectedDataEmitter)="msUpdate($event, 'PLAYER_SOFTWARE')" [showColumnIcon]="false"
              [showIcon]="false"
              [msOptions]="msPlayerSoftwareOptions" (msOptionsChange)="msRequest('PLAYER_SOFTWARE', $event)"
              [selectedInputData]="playerSoftware ? [playerSoftware] : []">
            </sb-comp-dropdown-select>
          </div>
        </div>
      </div>

      <div class="d-flex flex-row bb" *ngPermissions="[permissionService.Permission.device_attributes_edit]">
        <div *ngIf="attributes?.length > 0"
             class="my-3 ml-3 w-100">
          <h5>
            {{ 'lang.globals.attributes'|translate }}
          </h5>
          <ng-container *ngIf="amount === 1">
            <div
              class="mt-3 align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header ml-0">
              <ng-scrollbar class="mt-2" style="height: 150px; width: 100%" [track]="'vertical'">

                <div *ngFor="let attribute of attributes" class="d-flex tw-mr-5 tw-mb-1">
                  <p class="w-100">{{ attribute.name }}</p>
                  <div class="d-flex justify-content-end w-100">
                    @if (attribute?.datatype?.allowedValues?.length > 0) {
                      <sb-comp-string-dropdown-select
                        class="w-100"
                        [singleSelectMode]="false" [showSubmit]="false" [hidePagination]="true"
                        [inputData]="attribute.datatype.allowedValues" [dropDownDatatype]="'ATTRIBUTE'"
                        (selectedDataEmitter)="updateAttribute(attribute, $event)" [showColumnIcon]="false"
                        [frontendSearch]="true"
                        [showIcon]="false"
                        [disabled]=" !attribute?.datatype?.adPlacerAbleToSet ||!permissionService.hasPermission(permissionService.Permission.device_attributes_edit)"
                        [selectedInputData]="getAttributeInputData(attribute)">
                      </sb-comp-string-dropdown-select>
                    } @else {
                      <input type="text" class="form-control text-right" placeholder="..."
                             [disabled]="!attribute?.datatype?.adPlacerAbleToSet || !permissionService.hasPermission(permissionService.Permission.device_attributes_edit)"
                             [(ngModel)]="attribute.value">
                    }
                  </div>
                </div>
              </ng-scrollbar>
            </div>
          </ng-container>
          <ng-container *ngIf="amount > 1">
            {{ 'lang.globals.attributesNotEditableOnMultiCreate'| translate }}
          </ng-container>

        </div>
      </div>

    </div>
  </div>
  <div class="d-flex flex-row justify-content-between mt-3 ">

    <button class="btn btn-secondary"
            (click)="cancel()">{{ 'lang.globals.cancel' | translate }}
    </button>
    <button class="btn btn-primary"
            [disabled]="!channel"
            (click)="ok()">{{ 'lang.globals.ok' | translate }}
    </button>
  </div>
</div>
<div *ngIf="showCreationQueue" class="*:tw-flex *:tw-justify-center">
  <div>{{ 'lang.globals.deviceCreationProcess' |translate }}</div>
  <div class="tw-font-semibold tw-text-2xl">
    {{ currentCreationIndex }} / {{ maxCreationIndex }}
  </div>
  <div class="tw-mt-4">
    <button type="button" class="btn btn-danger" (click)="destroyCreationProcess()">{{ 'lang.globals.cancel'|translate }}</button>
  </div>

</div>
